import { ResourceOptions } from 'react-admin';
import { MdOutlineAccountBalance } from 'react-icons/md';

import { Resources } from '../../resource';

export { default as list } from './List';
export { OFFICIAL_VAULTS_PERMISSION_RESOURCE } from './constants';

export const name = Resources.vaultOfficialVaults;
export const icon = MdOutlineAccountBalance;
export const options: ResourceOptions = {
  label: 'module.officialVaults.title',
};
